var generateStyle = function generateStyle(componentTheme) {
  return {
    sectionHeading: {
      paddingTop: componentTheme.sectionHeadingPaddingTop,
      paddingBottom: componentTheme.sectionHeadingPaddingBottom
    },
    instructions: {
      paddingBottom: componentTheme.instructionsPaddingBottom
    },
    generateSolutionsInput: {
      paddingTop: componentTheme.generateSolutionsInputPaddingTop
    },
    generateButtonWrapper: {
      padding: componentTheme.generateButtonPaddingLeft
    },
    generatedSolutions: {
      paddingTop: componentTheme.generatedSolutionsPaddingTop
    },
    marginText: {
      paddingLeft: componentTheme.marginTextPadding,
      paddingRight: componentTheme.marginTextPadding
    },
    /* Table styles */

    marginPlusMinus: {
      fontWeight: componentTheme.marginPlusMinusWeight,
      color: componentTheme.marginPlusMinusColor
    },
    tableWrapper: {
      overflow: 'auto',
      '> table': {
        maxWidth: 'initial'
      }
    }
  };
};
export default generateStyle;